import React from "react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

export const LIFECYCLE_ACTIONS = {
  disable: {
    label: "Disable",
    title: "Pause the account (reversible)",
    body: "Signs the lawyer out everywhere, removes them from the marketplace and sets them offline. Data is kept. The lawyer can re-enable it themselves from the recovery screen, or you can here. They receive an email.",
    className: "border-amber-300 text-amber-700 hover:bg-amber-50",
  },
  suspend: {
    label: "Suspend",
    title: "Disciplinary hold (admin-only release)",
    body: "Same effect as Disable, but the lawyer cannot lift it — only an admin can re-enable. They are emailed and told to contact support.",
    className: "border-red-300 text-red-700 hover:bg-red-50",
  },
  reenable: {
    label: "Re-enable",
    title: "Restore login",
    body: "Lifts a disable or suspension. Does NOT re-list the lawyer or set them online — approve listing again separately.",
    className: "border-emerald-300 text-emerald-700 hover:bg-emerald-50",
  },
  delete: {
    label: "Delete",
    title: "Permanent off-boarding (cannot be undone)",
    body: "Anonymises personal data, frees the phone/BCI identity, revokes listing and verification. Blocked while payouts or consultations are still pending. Records needed by law are retained.",
    className: "border-red-300 text-red-700 hover:bg-red-50",
  },
};

export function LifecycleButton({ op, onClick, testid }) {
  const a = LIFECYCLE_ACTIONS[op];
  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button onClick={onClick} data-testid={testid} aria-label={`${a.label}: ${a.title}`}
                  className={`px-2 py-1 text-xs font-bold rounded-md border ${a.className}`}>{a.label}</button>
        </TooltipTrigger>
        <TooltipContent side="top" className="max-w-xs bg-[#0A2540] text-white" data-testid={`${testid}-tooltip`}>
          <p className="font-bold">{a.title}</p>
          <p className="mt-1 font-normal leading-relaxed text-slate-200">{a.body}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
